module.exports = __webpack_public_path__ + "static/media/main-img.4ae89ad3.jpg";